export const enfermedades = [
  { codigo: 'H1', nombre: 'Hipertensión Arterial' },
  { codigo: 'D1', nombre: 'Diabetes' },
  { codigo: 'T1', nombre: 'Tumores malignos o cáncer' },
  { codigo: 'I1', nombre: 'Infección por VIH' },
  { codigo: 'C1', nombre: 'Cataratas' },
  { codigo: 'D2', nombre: 'Desgaste en los huesos' },
  { codigo: 'H2', nombre: 'Hernia de disco en la columna' },
  { codigo: 'D3', nombre: 'Desviación del tabique nasal' },
  { codigo: 'P1', nombre: 'Piedras en la vesícula' },
  { codigo: 'C2', nombre: 'Colesterol o triglicéridos altos' },
];
